import {Box, Grid,} from "@mui/material";
import MatchVideoPlayer from "../MatchVideoPlayer/MatchVideoPlayer";
import ClipsPlaylist from "../../ClipsComponents/ClipsPlaylist/ClipsPlaylist";
import {useEffect, useRef, useState} from "react";
import {Event} from "../../../types/eventTypes"
import {useTheme} from "../../../contexts/theme";
import {Clip, GroupedClips, Highlight, VideoContentTypes, VideoUpdatableFields} from "../../../types/clipTypes";

interface MatchPlayerContainerProps {
    event: Event | undefined;
    groupedClips: GroupedClips | undefined;
    streamUrl: string;
    onDeleteClip: (clipId: Clip) => void;
    onDeleteAllJobClips: (jobId: string) => void;
    onDeleteAllKeyMomentClips: (keyMoment: string) => void;
    onDeleteHighlight: (highlight: Highlight) => void;
    onVideoContentUpdate: (videoContentId: string, contentType: VideoContentTypes, field: VideoUpdatableFields, value: string[] | string) => void;
    setSortAsc: (sortAscending: boolean) => void;
    sortAsc: boolean;
    clipDeleting: boolean;
    firstLoading: boolean;
    minRunningJobsStatus: string
}

const MatchPlayerContainer: React.FC<MatchPlayerContainerProps> = ({minRunningJobsStatus, onVideoContentUpdate, firstLoading, clipDeleting, sortAsc,  setSortAsc, onDeleteHighlight, onDeleteAllKeyMomentClips, onDeleteAllJobClips, onDeleteClip, streamUrl, groupedClips, event}) => {
    const theme = useTheme();
    const [videoHeight, setVideoHeight] = useState(0);
    const videoContainerRef = useRef<HTMLDivElement>(null);
    const [titleHeight, setTitleHeight] = useState(0);
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const [playerMuted, setPlayerMuted] = useState(false);
    const wasMutedRef = useRef<boolean>(false);

    function getPlaylistHeight(){
        if (!videoHeight && videoContainerRef.current){
            return videoContainerRef.current.clientWidth * 9 /16;
        }
        if (videoHeight){
            return videoHeight
        }
        return 0;
    }

    useEffect(() => {
        if(isEditorOpen){
            wasMutedRef.current = JSON.parse(JSON.stringify(playerMuted));
            setPlayerMuted(true);
        }else{
            setPlayerMuted(wasMutedRef.current);
        }
    }, [isEditorOpen])

    return (
        <Box sx={{overflow:'auto', height: '100%', width: '100%', backgroundColor:theme.palette.black, padding: theme.spacing.md }}>
            <Grid container>
                <Grid ref={ videoContainerRef } item xs={12} md={8} sx={{ display: 'flex', flexDirection: 'column', height: '100%', paddingRight: {md:theme.spacing.none, lg:theme.spacing.md}}}>
                    <MatchVideoPlayer
                        muted={playerMuted}
                        setMuted={setPlayerMuted}
                        title={ event ? event.name : ''}
                        url={streamUrl}
                        setVideoHeight={setVideoHeight}
                        setTitleHeight={setTitleHeight}
                    />
                </Grid>
                <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <ClipsPlaylist
                        firstLoading = {firstLoading}
                        event={event}
                        setOutEditorOpen={setIsEditorOpen}
                        groupedClips={groupedClips}
                        height={getPlaylistHeight()}
                        onDeleteClip={onDeleteClip}
                        onDeleteAllJobClips = {onDeleteAllJobClips}
                        onDeleteAllKeyMomentClips = {onDeleteAllKeyMomentClips}
                        onDeleteHighlight = {onDeleteHighlight}
                        sortAsc={sortAsc}
                        setSortAsc={setSortAsc}
                        clipDeleting={clipDeleting}
                        onVideoContentUpdate={onVideoContentUpdate}
                        streamUrl = {streamUrl}
                        minRunningJobsStatus = {minRunningJobsStatus}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default MatchPlayerContainer